import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getPreAccount(uuid) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/pre-account/${uuid}`;
        return this.api.get(uri);
    }
    sendValidationPhone(sendValidationPhoneDto) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/send-validation-phone/`;
        return this.api.post(uri, sendValidationPhoneDto);
    }
    sendCodeDevice(codeDeviceValidationDto) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/send-code-device/`;
        return this.api.post(uri, codeDeviceValidationDto);
    }
    createPassword(id, preAccount) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/password-data/${id}`;
        return this.api.put(uri, preAccount);
    }
    resendCode(resendCodeDto) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/send-code-device/resend`;
        return this.api.post(uri, resendCodeDto);
    }
};
SpeNOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountProxy = __decorate([
    Injectable()
], SpeNOpenAccountProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_VIEW_PRE_ACCOUNT = '/spe-view-pre-account';
let SpeViewPreAccountProxy = class SpeViewPreAccountProxy {
    constructor(api) {
        this.api = api;
    }
    findDevice(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/device-validation/${id}`;
        return this.api.get(uri);
    }
    findAccountMigration(id) {
        const uri = `${SPE_VIEW_PRE_ACCOUNT}/v1/migration/${id}`;
        return this.api.get(uri);
    }
};
SpeViewPreAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewPreAccountProxy = __decorate([
    Injectable()
], SpeViewPreAccountProxy);

let UiPxDeviceValidationModule = class UiPxDeviceValidationModule {
};
UiPxDeviceValidationModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeNOpenAccountProxy,
            SpeViewPreAccountProxy,
            ConfigService
        ]
    })
], UiPxDeviceValidationModule);

/*
 * Public API Surface of ui-bs-device-validation-proxy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeNOpenAccountProxy, SpeViewPreAccountProxy, UiPxDeviceValidationModule };
//# sourceMappingURL=wlp-ui-px-device-validation.js.map
